import keyMirror from 'keymirror';

export default keyMirror({
  pink0: null,
  green0: null,
  yellow0: null,
  orange0: null,
  brown0: null,
  red0: null,
  black0: null,
  blue0: null,
  purple0: null,
  pink1: null,
  green1: null,
  yellow1: null,
  orange1: null,
  brown1: null,
  red1: null,
  black1: null,
  blue1: null,
  purple1: null,
  pink2: null,
  green2: null,
  yellow2: null,
  orange2: null,
  brown2: null,
  red2: null,
  black2: null,
  blue2: null,
  purple2: null,
  pink3: null,
  green3: null,
  yellow3: null,
  orange3: null,
  brown3: null,
  red3: null,
  black3: null,
  blue3: null,
  purple3: null,
  pink4: null,
  green4: null,
  yellow4: null,
  orange4: null,
  brown4: null,
  red4: null,
  black4: null,
  blue4: null,
  purple4: null,
  pink5: null,
  green5: null,
  yellow5: null,
  orange5: null,
  brown5: null,
  red5: null,
  black5: null,
  blue5: null,
  purple5: null,
});
